import script from "./OTPRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./OTPRegistration.vue?vue&type=script&setup=true&lang=js"

import "./OTPRegistration.vue?vue&type=style&index=0&id=01eb355a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01eb355a"]])

export default __exports__